import React, { useEffect, useState } from "react";
import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import {
  ConfirmDelete,
  MwInputText,
  MwSpinnerButton,
  NewButton,
  NewInputLang,
} from "../../components/ui";
import { IoMdAdd } from "react-icons/io";
import { BiEdit } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { useCurrent, useDelete, useFetch, usePost, usePut } from "../../hooks";

const ReceiptVoucherTypes = ({ apiBaseUrl }) => {
  const { t } = useTranslation("settings");
  const [langar, setLangar] = useState(true);
  const [incomesList, setIncomeList] = useState([]);
  const [incomeCode, setIncomeCode] = useState("");
  const [incomeName, setIncomeName] = useState("");
  const [incomeEnName, setIncomeEnName] = useState("");
  const [error, setError] = useState({});
  const [onShow, setOnShow] = useState(false);
  const [selectedIncomeId, setSelectedIncomeId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIncomeId, setEditingIncomeId] = useState(null);
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangId } =
    useCurrent();
  const { postData, loading } = usePost();
  const { loading: delloading, deleteItem } = useDelete();
  const canFetchContext = Boolean(
    currentTenantId && currentCompanyId && currentBranchId
  );
  const baseFinanceUrl = (apiBaseUrl || process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL || "").replace(/\/+$/, "");
  const buildFinanceUrl = (path) =>
    `${baseFinanceUrl}/${String(path || "").replace(/^\/+/, "")}`;
  const {
    data: incomesResult,
    loading: loadingIncomes,
    refreshHandler: refetchIncomes,
  } = useFetch(
    canFetchContext && baseFinanceUrl
      ? buildFinanceUrl(
          `incomes-types/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        )
      : null
  );
  const { data: incomesCountResult, refreshHandler } = useFetch(
    canFetchContext && baseFinanceUrl
      ? buildFinanceUrl(
          `incomes-types/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        )
      : null
  );
  const { loading: saveloading, putData } = usePut();

  useEffect(() => {
    if (incomesCountResult && !isEditing) {
      setIncomeCode((parseInt(incomesCountResult?.data) + 1).toString());
    }
  }, [incomesCountResult, isEditing]);

  useEffect(() => {
    if (incomesResult?.data) {
      setIncomeList(incomesResult.data);
    }
  }, [incomesResult]);

  const addIncome = () => {
    let errors = {};

    if (!incomeCode) errors.code = "Code Is Required";
    if (langar && !incomeName) {
      errors.name_ar = "Arabic And English Name Is Required";
    }
    if (!langar && !incomeEnName) {
      errors.name_en = "English And Arabic Name Is Required";
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    const incomeData = {
      code: incomeCode,
      name_ar: incomeName || "-",
      name_en: incomeEnName || "-",
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    const resetForm = () => {
      setIncomeCode("");
      setIncomeName("");
      setIncomeEnName("");
      setIsEditing(false);
      setEditingIncomeId(null);
      setError({});
    };

    if (!baseFinanceUrl) return;
    if (!isEditing) {
      postData(
        buildFinanceUrl("incomes-types"),
        incomeData
      ).then(() => {
        refetchIncomes();
        refreshHandler();
        resetForm();
      });
    } else {
      putData(
        buildFinanceUrl(`incomes-types/${editingIncomeId}`),
        incomeData
      ).then(() => {
        refetchIncomes();
        refreshHandler();
        resetForm();
      });
    }
  };

  const deleteIncome = (id) => {
    if (!baseFinanceUrl) return;
    deleteItem(buildFinanceUrl(`incomes-types/${id}`)).then(() => {
      refetchIncomes();
      refreshHandler();
      setOnShow(false);
    });
  };

  return (
    <>
      {!incomeCode ? (
        <div className="h-20 w-full justify-center items-center flex">
          <MwSpinnerButton />
        </div>
      ) : (
        <section className="flex flex-col flex-1">
          <ConfirmDelete
            onShow={onShow}
            setOnShow={setOnShow}
            onDeleteHandler={() => deleteIncome(selectedIncomeId)}
            loading={delloading}
            msg={t("income.incomedel")}
          />
          <div className="flex justify-start w-full items-end gap-2">
            <div className="w-28">
              <MwInputText
                invalid={error?.code}
                disabled={true}
                label={t("income.incomecode")}
                value={incomeCode}
                onChange={(e) => setIncomeCode(e.target.value)}
                classNameInput="w-[100%] text-center  flex-1  "
              />
            </div>
            <div className="w-80 flex flex-col justify-center">
              <NewInputLang
                invalid={error?.name_ar || error?.name_en}
                placeholder={t("income.incomenameplaceholder")}
                label={t("income.incomename")}
                value={langar ? incomeName : incomeEnName}
                langar={langar}
                onChange={(value) => {
                  if (langar) {
                    setIncomeName(value);
                  } else {
                    setIncomeEnName(value);
                  }
                }}
                onChangeLang={() => setLangar(!langar)}
                classNameInput="w-[100%] flex-1"
              />
            </div>

            <div className="group">
              <NewButton onClick={addIncome}>
                {loading || saveloading ? (
                  <MwSpinnerButton />
                ) : isEditing ? (
                  t("general.update")
                ) : (
                  <>
                    <IoMdAdd className="text-white text-lg group-hover:text-[#ffffff]" />
                    <p className="">{t("general.Add")}</p>
                  </>
                )}
              </NewButton>
            </div>
          </div>

          {loadingIncomes && incomesList?.length === 0 ? (
            <div className="h-40 flex justify-center items-center w-full">
              <MwSpinnerButton />
            </div>
          ) : incomesList?.length > 0 ? (
            <>
              <>
                <div className="flex w-full mt-3 justify-around bg-[#F2F0FC] p-3 rounded-t-lg font-[800] text-[#251658] text-sm">
                  <div className="w-0 text-center">#</div>
                  <div className="w-52 text-center">
                    {t("income.incomecode")}
                  </div>
                  <div className="flex-1 text-center">
                    {t("income.incomename")}
                  </div>
                  <div className="flex-1 text-center"></div>
                </div>
                <div className="divide-y  ">
                  {incomesList.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-full border-b border-[#ddd0bf] border-opacity-25 cursor-pointer justify-around items-center p-3 text-[#251658] font-semibold text-sm"
                    >
                      <div className="w-1 text-center">{index + 1}</div>
                      <div className="w-52 text-center">{item?.code}</div>
                      <div className=" flex-1 text-center">
                        {currentLangId === "ar" ? item?.name_ar : item?.name_en}
                      </div>
                      <div className=" flex me-4 justify-end items-center flex-1 text-end gap-1">
                        <button
                          onClick={() => {
                            setIsEditing(true);
                            setEditingIncomeId(item.id);
                            setIncomeCode(item.code);
                            setIncomeEnName(item.name_en);
                            setIncomeName(item.name_ar || item.name_en || item.name);
                          }}
                          className="text-blue-500 hover:text-blue-700 mx-2"
                        >
                          <BiEdit size={16} />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedIncomeId(item.id);
                            setOnShow(true);
                          }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <RiDeleteBinLine size={16} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </>
          ) : (
            <div className=" h-[calc(100vh-230px)] ">
              <SettingsEmptyState msg={t("income.validate")} />
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default ReceiptVoucherTypes;
